import { render } from "./Banner.vue?vue&type=template&id=13c99c08"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"
script.render = render

export default script